export default {
    "savedQueries": {
        "savedQueries": "Gespeicherte Suchanfragen",
        "saveCurrentQuery": "Aktuelle Suchanfrage speichern",
        "manageSavedQueries": "Aktuelle Suchanfragen verwalten",
        "savedQueryAlreadyExists": "Es existiert bereits eine Suchanfrage mit diesem Namen. Möchten Sie sie ersetzen?",
        "noSavedQuery": "Sie haben noch keine Suchanfrage gespeichert...",
        "delete": "Löschen Sie diese gespeicherte Suche"
    },

    "recentQueries": {
        "noRecentQuery": "Sie haben noch keine Suche durchgeführt...",
        "delete": "Löschen Sie diese letzte Suche",
        "save": "Speichern Sie diese letzte Suche"
    },

    "recentDocuments": {
        "recentDocuments": "Kürzlich angesehenes Dokument",
        "noRecentDocument": "Sie haben kein Dokument angezeigt",
        "delete": "Löschen Sie dieses kürzlich angezeigte Dokument"
    },

    "editSavedQuery": {
        "title": "Gespeicherte Suchanfrage",
        "name": "Name"
    },

    "exportQuery": {
        "dialogTitle": "Export",
        "dialogOutputFormat": "Ausgabeformat",
        "dialogMaxCount": "Maximale Anzahl der Zeilen",
        "dialogSourceType": "Exportiere ...",
        "dialogResult": "aktuelle Ergebnisliste",
        "dialogSelection": "aktuelle Auswahl",
        "btnTitle": "Export",
        "exportResult": "Exportiere die Ergebnisliste als {type}",
        "exportSelection": "Exportiere die Auswahl als {type}",
        "btnDownload": "Herunterladen",
        "btnClose": "Schließen",
        "successNotification": "Herunterladen beendet",
        "exportedColumns": "Zu exportierende Spalten",
        "exportedColumnsLabelTooltip": "Wählen Sie die Spalten aus, die Sie exportieren möchten. Eine leere Auswahl bedeutet, dass alle Spalten exportiert werden",
        "dialogMaxCountTooltip": "Standardmäßig ist die Anzahl der Ergebnisse auf {count} begrenzt"
    },

    "manageSavedQueries": {
        "title": "Gespeicherte Suchanfragen verwalten",
        "save": "Aufzeichnung",
        "reorder": "Neu sortieren",
        "remove": "Entfernen",
        "removeAll": "Alle entfernen",
        "export": "Exportieren",
        "name": "Name",
        "rss": "RSS-Feed"
    },

};
